/**
 * @param {string[]|null} accept
 * @param {boolean} multiple
 * @returns {Promise<FileList>}
 */
export async function importFiles(accept, multiple = false) {
  return new Promise((resolve) => {
    const element = document.createElement("input");

    element.setAttribute("type", "file");

    if (accept) {
      element.setAttribute("accept", accept.join(","));
    }

    if (multiple) {
      element.setAttribute("multiple", multiple.toString());
    }

    element.onchange = async () => {
      if (!element.files || element.files.length === 0) {
        return;
      }

      resolve(element.files);
    };

    element.click();
  });
}

/**
 * @param {string} data
 * @param {string} type
 * @param {string} name
 * @returns {void}
 */
export function exportFiles(data, type, name) {
  const a = document.createElement("a");

  const blob = new Blob([data], { type });

  a.href = URL.createObjectURL(blob);

  a.setAttribute("download", name);

  a.click();
}
